// @flow
import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px ${({ theme }) => theme.metrics.largeMargin}px;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

function DialogFooter({ children, style }: { children?: React.Node, style?: Object }) {
  return (
    <Wrapper style={style}>
      {children}
    </Wrapper>
  );
}

export default DialogFooter;



// WEBPACK FOOTER //
// ./src/common/components/DialogFooter.js